import React from 'react';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/components/capstone/base';
import MaskVisibility from '../MaskVisibility/';
import {
  IntegrationTable,
  IntegrationTableHead,
  IntegrationTableBody,
  IntegrationTableTD,
  IntegrationTableTH,
  IntegrationTableTR,
  LoaderOverlay,
  TableWrapper,
  CustomErrorWrapper,
} from './IntegrationTests.styles';

const IntegrationTests = props => {
  const { integrations, testing } = props;
  const RAVESMART_911 = 'Rave Smart911';
  const IAR = 'IaR';

  const getStatus = integration => {
    if (integration.apisData.find(item => item.status === 'fail')) {
      return 'Failed';
    } else if (integration.apisData.find(item => item.status === 'pass')) {
      return 'Passed';
    } else {
      return null;
    }
  };

  //Hide Rave Smart911 and IaR from outbound integration page in RSP MC-21691 and COR-2104
  const filteredIntegrationsNames = integrations.filter(
    integration =>
      integration.name !== RAVESMART_911 && integration.name !== IAR,
  );

  return (
    <TableWrapper>
      <IntegrationTable>
        <IntegrationTableHead>
          <IntegrationTableTR>
            <IntegrationTableTH>
              Integrated Solution Partners
            </IntegrationTableTH>
            <IntegrationTableTH>Client ID</IntegrationTableTH>
            <IntegrationTableTH>Client Secret</IntegrationTableTH>
            <IntegrationTableTH>Status</IntegrationTableTH>
          </IntegrationTableTR>
        </IntegrationTableHead>
        <IntegrationTableBody>
          {filteredIntegrationsNames.map(integration => (
            <IntegrationTableTR key={integration.name}>
              <IntegrationTableTD>{integration.name}</IntegrationTableTD>
              {typeof integration.name === 'string' && (
                <>
                  <IntegrationTableTD>
                    <MaskVisibility text={integration.credentials.client_id} />
                  </IntegrationTableTD>
                  <IntegrationTableTD>
                    <MaskVisibility
                      text={integration.credentials.client_secret}
                    />
                  </IntegrationTableTD>
                </>
              )}
              <IntegrationTableTD data-name="integration-status-text">
                {getStatus(integration)}
              </IntegrationTableTD>
              {integration.apisData.some(function (el) {
                return el.status === 'fail';
              }) &&
                integration.apisData.map((item, index) => {
                  if (item.error) {
                    return (
                      <CustomErrorWrapper key={integration.name + index}>
                        <Box>
                          <AttentionTriangleIcon height={12} width={13} />
                        </Box>
                        <Text size="small">{item.error}</Text>
                      </CustomErrorWrapper>
                    );
                  }
                })}
            </IntegrationTableTR>
          ))}
        </IntegrationTableBody>
      </IntegrationTable>
      {testing && <LoaderOverlay />}
    </TableWrapper>
  );
};

export default IntegrationTests;
